import { IDBPDatabase, openDB } from 'idb'
import { IUserKeyStore } from '@/contracts/system-modules/auth/key/IUserKeyStore'

// Одна база на браузер, запись на учётную запись: IndexedDB хранит неизвлекаемый
// CryptoKey, не открывая его байтов. Записи удаляются по одной, базу искать не нужно.
const DATABASE = 'extasy.keys'
const VERSION = 1
const KEYS = 'keys'

export class UserKeyStore implements IUserKeyStore {
  private database: Promise<IDBPDatabase<unknown>> | null = null

  async save(userUuid: string, key: CryptoKey): Promise<void> {
    await (await this._database()).put(KEYS, key, userUuid)
  }

  async load(userUuid: string): Promise<CryptoKey | null> {
    const key = await (await this._database()).get(KEYS, userUuid)

    return key instanceof CryptoKey ? key : null
  }

  async remove(userUuid: string): Promise<void> {
    await (await this._database()).delete(KEYS, userUuid)
  }

  _database(): Promise<IDBPDatabase<unknown>> {
    if (!this.database) {
      this.database = openDB(DATABASE, VERSION, {
        upgrade(upgrading) {
          upgrading.createObjectStore(KEYS)
        },
      })
    }

    return this.database
  }
}
